















































































import InfiniteScroll from "@monorepo/uikit/src/components/tableViews/InfiniteScroll.vue";
import Table from "@monorepo/uikit/src/components/common/Table.vue";
import SortPanelContainer from "@monorepo/uikit/src/components/common/SortPanelContainer.vue";
import TableHeader from "@monorepo/uikit/src/components/tableViews/TableHeader.vue";
import Filters from "@monorepo/uikit/src/components/common/Filters.vue";
import TableSettings from "@monorepo/uikit/src/components/tableViews/TableSettings.vue";
import AKInfoModal from "@monorepo/inventory/src/views/AKView/components/AKInfoModal.vue";
import ToggleTableCellsContainer from "@monorepo/inventory/src/views/AKView/components/ToggleTableCellsContainer.vue";
import Breadcrumbs from "@monorepo/uikit/src/components/common/Breadcrumbs.vue";
import ExportButton from "@monorepo/uikit/src/components/tableViews/ExportButton.vue";
import ScrollPanel from "@monorepo/uikit/src/components/tableViews/ScrollPanel.vue";
import Footer from "@monorepo/uikit/src/components/common/Footer.vue";
import { tableHeaders } from "@monorepo/utils/src/variables/projectsData/akView/tableHeaders";
import { viewTitle, viewUniqKey } from "@monorepo/utils/src/variables/projectsData/akView/viewTitle";
import { defineComponent, ref } from "@vue/composition-api";
import useGetTableLibs from "./composables/useGetTableLibs";
import useSetStartFilters from "@monorepo/utils/src/composables/useSetStartFilters";
import { mapActions, mapGetters, Module } from "vuex";
import { breadcrumbs } from "@monorepo/inventory/src/views/AKView/constants/breadcrumbs";
import useInitTableStoreModule from "@monorepo/utils/src/store/composables/useInitTableStoreModule";
import { akView } from "@monorepo/inventory/src/store/modules/akView";
import useRefreshTable from "@monorepo/utils/src/composables/useRefreshTable";
import AutoRefreshButton from "@monorepo/uikit/src/components/tableViews/AutoRefreshButton.vue";
import useInitEducationPanel from "@monorepo/utils/src/composables/useInitEducationPanel";
import useSetStartCells from "@monorepo/utils/src/composables/useSetStartCells";
import useSetStartModal from "@monorepo/utils/src/composables/useSetStartModal";
import { authorities } from "@monorepo/utils/src/authorities/authorities";
import { isAuthorityExist } from "@monorepo/utils/src/utils/isAuthorityExist";
import useOpenHistoryMode from "@monorepo/utils/src/composables/useOpenHistoryMode";
import ExportFooterButton from "@monorepo/uikit/src/components/tableViews/ExportFooterButton.vue";
import { convertApiItemToUi } from "@monorepo/inventory/src/views/AKView/utils/convertApiItemToUi";
import { fields } from "@monorepo/utils/src/variables/projectsData/akView/fields";
import useMoveByAuthorities from "@monorepo/utils/src/composables/useMoveByAuthorities";
import { filtersElements } from "@monorepo/utils/src/variables/projectsData/akView/filtersElements";
import { currentFilters as setCurrentFilters } from "@monorepo/inventory/src/views/AKView/utils/defaultCurrentFilters";
import { convertToSelectItems } from "@monorepo/utils/src/utils/convertToSelectItems";
import useAsyncExport from "@monorepo/utils/src/composables/useAsyncExport";

const SECTION_NAME = "akView";

export default defineComponent({
  name: "AkView",
  components: {
    TableSettings,
    Table,
    Filters,
    InfiniteScroll,
    ScrollPanel,
    ExportButton,
    TableHeader,
    Breadcrumbs,
    SortPanelContainer,
    AKInfoModal,
    ToggleTableCellsContainer,
    AutoRefreshButton,
    Footer,
    ExportFooterButton,
  },
  data() {
    return {
      breadcrumbs,
      viewTitle,
      viewUniqKey,
      tableHeaders,
      pluralFormTitles: ["АК"],
      convertApiItemToUi,
      filtersElements,
      setCurrentFilters,
      autocompleteFiltersKeys: [fields.OIK_NAME],
    };
  },
  computed: {
    ...mapGetters("auth", ["isOpenEducation", "user"]),
    ...mapGetters(SECTION_NAME, [
      "cells",
      "isOpenFilters",
      "data",
      "openedId",
      "isSelectAll",
      "infiniteId",
      "totalLength",
      "selectedIds",
      "isTableLoading",
      "autorefresh",
      "isLoadingChangeAutorefresh",
    ]),
    ...mapGetters("akView", ["statusesLibrary", "typesLibrary"]),
    statuses(): { title: string; value: string }[] {
      return convertToSelectItems(this.statusesLibrary);
    },
    types(): { title: string; value: string }[] {
      return convertToSelectItems(this.typesLibrary, "name", "code");
    },
    selectItemsObj(): Record<string, unknown> {
      return {
        statuses: this.statuses,
        types: this.types,
      };
    },
    isShowExport(): boolean {
      return isAuthorityExist(this.user, authorities.AK_EXPORT);
    },
    isShowFooter(): boolean {
      return (this.isSelectAllElement || !!Object.values(this.selectedIds).filter(Boolean).length) && this.isShowExport;
    },
    isShowModal(): boolean {
      return !this.isOpenEducation && Boolean(this.openedId);
    },
    isSelectAllElement: {
      get(): boolean {
        return this.isSelectAll;
      },
      set(value: boolean) {
        this.$store.dispatch(`${SECTION_NAME}/setIsSelectAll`, value);
      },
    },
  },
  methods: {
    ...mapActions(SECTION_NAME, ["getEventList", "getExportData", "addOpenedId", "setIsOpenFilters", "setAutorefresh"]),
    ...mapActions(SECTION_NAME, { setCellsAk: "setCells" }),
    openModalIfNeed() {
      if (this.$route.query?.isOpenModal && this.data.length) {
        if (this.$route.query?.id) {
          this.addOpenedId(this.$route.query?.id as string);
          this.showModal = true;
          return;
        }
        this.addOpenedId(this.data[0].id);
        this.showModal = true;
      } else if (this.$route.query?.card && this.data.length) {
        this.addOpenedId(this.$route.query?.card as string);
        this.showModal = true;
      }
    },
    openModal({ header, event }: { header: { value: string; isLink: boolean }; event: Record<string, unknown> }) {
      switch (header.value) {
        case "openModal":
          if (event.id) {
            this.addOpenedId(event.id);
            this.toggleModal(true);
          }
          break;
        case fields.TK_ID:
          this.moveByAuthorities(header, "/inventory/tk", {
            id: event[fields.TK_ID as keyof ReturnType<typeof convertApiItemToUi>] as string,
            isOpenModal: "1",
          });
          break;
        case fields.OIK_NAME:
          if (event[fields.OIK_NAME as keyof ReturnType<typeof convertApiItemToUi>]) {
            this.moveByAuthorities(header, "/dictionaries/oik", {
              name: event[fields.OIK_NAME as keyof ReturnType<typeof convertApiItemToUi>] as string,
              id: event[fields.OIK_ID as keyof ReturnType<typeof convertApiItemToUi>] as string,
              isOpenModal: "1",
            });
          }
          break;
        default:
          break;
      }
    },
    toggleModal(value: boolean) {
      this.showModal = value;
      if (!value) {
        this.$store.dispatch(`${SECTION_NAME}/addOpenedId`, null);
      }
    },
    setCells(value: Record<string, unknown>[]) {
      this.setCellsAk(value.map((item) => item.value));
    },
  },
  setup(props, { root }) {
    const filtersLoaded = ref(false);
    const showModal = ref(false);
    const sectionName = ref(SECTION_NAME); // sectionName === store module name
    const moveByAuthorities = useMoveByAuthorities(root);

    useInitTableStoreModule(root, SECTION_NAME, akView as Module<unknown, unknown>);
    useOpenHistoryMode(root, SECTION_NAME);
    useSetStartCells(root, SECTION_NAME, root.$store.getters[`${SECTION_NAME}/section`], tableHeaders, true).then(() => {
      useRefreshTable(root, SECTION_NAME);
    });
    useSetStartFilters(root, SECTION_NAME, ["id"]).then(() => {
      useInitEducationPanel(root);
      filtersLoaded.value = true;
      useSetStartModal(root, SECTION_NAME);
      if (root.$store.getters[`${SECTION_NAME}/openedId`]) {
        showModal.value = true;
      }
    });
    useGetTableLibs(root);
    useAsyncExport(root, SECTION_NAME);

    return {
      filtersLoaded,
      showModal,
      sectionName,
      moveByAuthorities,
    };
  },
});
